import { Navigate } from 'react-router-dom'
import { url } from '../../../Server/url/GlobalUrl';


const CommonRegistrationApi = (data,registerThis) => {
    console.log('data',data)
    var responce = "";
    fetch(url + '/api/user/', {
        method: 'POST',
        headers: {
            'Accept': 'application/json, text/plain',
            'Content-Type': 'application/json;charset=UTF-8'
        },
        body: JSON.stringify(data)

    })
        .then((response) => {
            console.log("response", response)
            if (response['status'] === 201) {
                responce = "Registration Successfull"
                localStorage.setItem('is_register_first_time',true)
                registerThis.showCustomModal()
                registerThis.setState({ strong_text: "Thanks for completing step 1 in the registration process." })
                registerThis.setState({ h1_text: "Please check your inbox for an email from us to complete the process." })
                registerThis.setState({ h5_text: " If you do not see the message within a few minutes check your spam box. If it is in spam please mark the message as not spam so any future messages will be directed to the inbox. Thank you." })
            } else if (response['status'] === 400) {
                responce = "Email aleady exists."
                registerThis.showCustomModal()
                registerThis.setState({ authResponse: 'Email aleady exists' })
            }

        }).catch(error => {
            console.log(error)
        });
};

export { CommonRegistrationApi };